import React, { useEffect, useRef } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import { deleteDashboardGroupStart } from "store/actions";
import { LayoutContext } from "App/common/hoc/Layout";
import { decodeHandler } from "utils";

function DeleteGroup(props) {
  const { lState, lMethods } = React.useContext(LayoutContext);
  const lStateRef = useRef();

  const [group, setGroup] = React.useState(lState.popup.params.group);
  React.useEffect(() => {
    lMethods.updatePopupParams({
      execute: handleDeleteChange
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [group]);

  /*****************************Handling  popup using enter key ***************************/
  useEffect(() => {
    lStateRef.current = lState;
    const handleKeyDown = e => {
      if (
        e.key === "Enter" &&
        lStateRef.current.popup.show &&
        lStateRef.current.popup.alertName === "dashboardGroupsDelete"
      ) {
        handleDeleteChange();
      }
    };

    document.addEventListener("keydown", handleKeyDown);
    // Cleanup: Remove the event listener when the component unmounts
    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [lState]);

  function handleDeleteChange() {
    props.deleteDashboardGroupStart({
      groupIDs: [+group.groupId],
      position: lState.popup.params.position
    });
    lMethods.closePopup();
    lState.popup.params.resetCheckList && lState.popup.params.resetCheckList();
  }

  return (
    <p className="">
      {"Are you sure you want to delete the group '" +
        decodeHandler(lState.popup.params.group.groupName) +
        "' permanently?"}
    </p>
  );
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      deleteDashboardGroupStart
    },
    dispatch
  );
}

export default connect(null, mapDispatchToProps)(DeleteGroup);
